<div *ngIf="graph">
  <plotly-plot
    [data]="graph.data"
    [layout]="graph.layout"
    [config]="graph.config">
  </plotly-plot>
</div>
